<template>
  <button class="syuusei" type="submit">修正する</button>
</template>

<style src="./modify-button.css"></style>
